<template>

  <!-- <sui-page> -->
    <!-- <sui-page-header :pageId="this.$options.name" /> -->
    <!-- <sui-page-contents> -->

  <div id="app">
    <div class="statsWrap">
      <div class="statsInfo">
        <strong>재시도 포함 통화시도 연결률</strong>
        <div class="chartWrap">
          <canvas id="myChart1" width="140" height="140"></canvas>
          <div class="per">{{callSuccessRatioStat}}<span>%</span></div>
        </div>
        <ul>
          <li><span>통화시도</span><span>{{callTotalCntStat}}</span></li>
          <li><span>예약접수</span><span>{{callReserveCntStat}}</span></li>
          <li><span>통화연결</span><span>{{callSuccessCntStat}}</span></li>
        </ul>
      </div>

      <div class="statsInfo">
        <strong>수신번호 기준 통화 연결률</strong>
        <div class="chartWrap">
          <canvas id="myChart2" width="140" height="140"></canvas>
          <div class="per">{{callSuccessRatioByCalleeStat}}<span>%</span></div>
        </div>
        <ul>
          <li><span>수신번호</span><span>{{calleeCntStat}}</span></li>
          <li><span>수행번호</span><span>{{callCntByCalleeStat}}</span></li>
          <li><span>통화연결</span><span>{{callSuccessCntByCalleeStat}}</span></li>
        </ul>
      </div>

      <div class="statsInfo">
        <strong>수신번호 기준 시나리오 종료율 </strong>
        <div class="chartWrap">
          <canvas id="myChart3" width="140" height="140"></canvas>
          <div class="per">{{scenarioEndRatioByCalleeStat}}<span>%</span></div>
        </div>
        <ul>
          <li><span>수신번호</span><span>{{calleeCntStat}}</span></li>
          <li><span>시나리오 시작</span><span>{{scenarioStartCntByCalleeStat}}</span></li>
          <li><span>시나리오 종료</span><span>{{scenarioEndCntByCalleeStat}}</span></li>
        </ul>
      </div>
      <!-- <div class="btnStatsView">
        <a href="#">데일리 캠페인 통계 보기</a>
      </div> -->
    </div>
  </div>

    <!-- </sui-page-contents> -->
  <!-- </sui-page> -->

</template>

<script>
import BasePage from '~cm/components/BasePage';/* 
import Chart from 'chart.js'; */

// import common from '~assets/css/aicc/common.css';
// import content from '~assets/css/aicc/content.css';
// import content1 from '~assets/css/aicc/content1.css';
// import content2 from '~assets/css/aicc/content1.css';
// import reset from '~assets/css/aicc/reset.css';

export default {
  name: 'PGE_AIC_00004_T02', // eslint-disable-line vue/name-property-casing

  extends: BasePage,
  
  components: {
    BasePage,
  }, 
  
  props: {
    outCallStatistics: {
      type: Object,
      default: null,
    },
  },
  
  data() {
  
    return {
      myChart : null,
    };
  },
 
  computed: {
    // scheduleName() {
    //   return this.outCallSchedule.scheduleName;
    // },

    // registerModifyInfo() {
    //   return this.getRegisterModifyDateInfo(this.outCallSchedule);
    // },

    // scheduleStatusInfo() {
    //   let statusName = '';
    //   if (this.outCallSchedule.scheduleStatus) {
    //     statusName = ScheduleStatus.getStausName(this.outCallSchedule.scheduleStatus);
    //   }      
    //   return statusName;
    // },

    // scheduleDateInfo() {
    //   return this.getScheduleDateInfo(this.outCallSchedule);
    // },
    
    // scheduleTimeInfo() {
    //   return this.outCallSchedule.startTimeLimit + " ~ " + this.outCallSchedule.endTimeLimit;
    // },

    // excludeSaturday() {
    //   return this.getExcludeSaturday(this.outCallSchedule);
    // },

    // excludeSundayHoliday() {
    //   return this.getExcludeSundayHoliday(this.outCallSchedule);
    // },

    // callerIdInfo() {
    //   return this.getCallerIdInfo(this.outCallSchedule);
    // },

    // scenarioId() {
    //   return this.outCallStatistics.scenarioId;
    // },

    callTotalCntStat() {
      return utils.numberFormat(this.outCallStatistics.callTotalCnt);
    },
    callSuccessCntStat() {
      return utils.numberFormat(this.outCallStatistics.callSuccessCnt);
    },
    callReserveCntStat() {
      return utils.numberFormat(this.outCallStatistics.callReserveCnt);
    },
    callSuccessRatioStat() {
      return utils.numberFormat(this.outCallStatistics.callSuccessRatio);
    },
    calleeCntStat() {
      return utils.numberFormat(this.outCallStatistics.calleeCnt);
    },
    callCntByCalleeStat() {
      return utils.numberFormat(this.outCallStatistics.callCntByCallee);
    },
    callSuccessCntByCalleeStat() {
      return utils.numberFormat(this.outCallStatistics.callSuccessCntByCallee);
    },
    callSuccessRatioByCalleeStat() {
      return utils.numberFormat(this.outCallStatistics.callSuccessRatioByCallee);
    },
    scenarioStartCntByCalleeStat() {
      return utils.numberFormat(this.outCallStatistics.scenarioStartCntByCallee);
    },
    scenarioEndCntByCalleeStat() {
      return utils.numberFormat(this.outCallStatistics.scenarioEndCntByCallee);
    },
    scenarioEndRatioByCalleeStat() {
      return utils.numberFormat(this.outCallStatistics.scenarioEndRatioByCallee);
    },
  },
 
  watch: {

  },
 
  created() {
    Chart.defaults.global.tooltips.enabled = false; 
  },

  mounted() { 
    // console.log('this.outCallStatistics', this.outCallStatistics);
    
    //this.createChart('myChart1', this.outCallStatistics.callSuccessRatio);
    //this.createChart('myChart2', this.outCallStatistics.callSuccessRatioByCallee);
    //this.createChart('myChart3', this.outCallStatistics.scenarioEndRatioByCallee);
    
  },
 
  beforeUpdate() {

  },
 
  updated() {
  },
 
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.destroy();
    }    
  },
 
  destroyed() {
    
  },
  methods: {
    showChart(){
          this.createChart('myChart1', this.outCallStatistics.callSuccessRatio);  
          this.createChart('myChart2', this.outCallStatistics.callSuccessRatioByCallee);
          this.createChart('myChart3', this.outCallStatistics.scenarioEndRatioByCallee);
      
    },
    showChartWithData(outCallStatistics){
          this.createChart('myChart1', outCallStatistics.callSuccessRatio);  
          this.createChart('myChart2', outCallStatistics.callSuccessRatioByCallee);
          this.createChart('myChart3', outCallStatistics.scenarioEndRatioByCallee);
    },
    createChart(chartId, percent) {
      // console.log(chartId +":::::::::::::::::"+ percent)
      var ctx = document.getElementById(chartId);
      // if(typeof myChart !== 'undefined'){
      //   myChart.destroy();
      // }
      
      this.myChart =  new Chart(ctx, {
          type: 'doughnut',
          data: {
            datasets: [{
              data: [percent, 100-percent],
              backgroundColor: [
                'rgb(86, 165, 255)',
                'rgb(225, 226, 232)'
              ],
              hoverOffset: 0,
              borderWidth: 0
            }],
            options: {
              responsive: true,
              tooltips: {
                enabled: false
              },
            }
          },
      }); 
            
      this.myChart.update();   
      
      Chart.defaults.global.showTooltips = false;
    }    
  },
  
};
</script>

<style scoped>

</style>